// AUTO-GENERATED from backend/src/utils/feature_flag_utils/catalog.py - do not edit.
export const FLAG = {
  SIMILARLY_SITUATED_BUILDER: '87a5d6d3f0edb320da701b978c9a2647',
} as const;

export type FlagName = keyof typeof FLAG;
